var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "root", staticClass: "lazy-cross-selling" }, [
    _c("div", {
      staticClass: "lazy-cross-selling-placeholder",
      staticStyle: { "min-height": "320px" },
      attrs: { "aria-hidden": "true" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }